import { DELETE_PRESS_ITEM } from "../../api";
import "./DeletePressItem.css";
import { useState } from "react";
import { useMutation } from "@apollo/client";
import { ReactComponent as CloseIcon } from "../../icons/close.svg";

export default function DeletePressItem({ setModal, update, pressItem }) {
  const [error, setError] = useState("");

  const [mutation, { loading }] = useMutation(DELETE_PRESS_ITEM, {
    onError: (e) => {
      console.log(e);
      setError(e.message);
    },
    update,
  });

  return (
    <div className="Modal-form-wrapper">
      <div className="Modal-form-wrapper__header">
        <div className="Modal-form-wrapper__header__title">Delete news</div>

        <div
          className="Modal-form-wrapper__header__dismiss"
          onClick={() => {
            setModal(false);
          }}
        >
          <CloseIcon style={{ height: "16px" }} />
        </div>
      </div>

      <form
        className="Modal-form-wrapper__form"
        onSubmit={(e) => {
          e.preventDefault();

          if (loading) return;

          if (!pressItem?.id) {
            setError("Invalid news item.");
            return;
          }

          mutation({
            variables: {
              id: pressItem.id,
            },
          });
        }}
      >
        <div className="Modal-form-wrapper__form__group">
          <div className="Modal-form-wrapper__form__group__label">
            Are you sure you want to delete {pressItem.title}?
          </div>
        </div>

        {error && (
          <div className="Modal-form-wrapper__form__error">{error}</div>
        )}

        <button
          type="submit"
          className={
            "Modal-form-wrapper__form__submit " + (loading ? "disabled" : "")
          }
        >
          Yes, delete
        </button>
      </form>
    </div>
  );
}
